import React from 'react';
import { HeroUIProvider } from '@heroui/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
// CEOVideoSection moved into Hero
// removed LiveProductDemo
import ProblemSolution from './components/ProblemSolution';
import WhatWeDo from './components/WhatWeDo';
import DemoBanner from './components/DemoBanner';
import CalendlySection from './components/ContactForm';
import PricingSection from './components/PricingSection';
import FrequentQuestions from './components/FrequentQuestions';
import Footer from './components/Footer';
import { LocaleProvider } from './contexts/LocaleContext';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import './App.css';

function App() {
  return (
    <HeroUIProvider>
      <LocaleProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route
              path="/"
              element={
                <>
                  <Navbar />
                  <Hero />
                  <WhatWeDo />
                  <PricingSection />
                  <DemoBanner />
                  <ProblemSolution />
                  <CalendlySection />
                  <FrequentQuestions />
                  <Footer />
                </>
              }
            />
          </Routes>
        </BrowserRouter>
      </LocaleProvider>
    </HeroUIProvider>
  );
}

export default App;
